import { TableHeadersType } from "../tableHeadersType";

export const USER_GROUP_LIST_HEADERS: TableHeadersType[] = [
  {
    label: 'User Group Name',
    value: 'group_name',
    defaultChecked: true,
    checked: true
  },
  {
    label: 'Updated By',
    value: 'updated_by_first_name',
    defaultChecked: true,
    checked: true
  },
]

export const GROUP_ASSIGNED_TO_USER_LIST_HEADERS=[
  {
    label: 'User Name',
    value: 'user_name',
    defaultChecked: true,
    checked: true
  },
  {
    label: 'Group Name',
    value: 'group_name',
    defaultChecked: true,
    checked: true
  }
  // ,
  // {
  //   label: 'Edit',
  //   value: 'edit',
  //   defaultChecked: true,
  //   checked: true
  // }
]